const defaultCurrencyFormatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  maximumFractionDigits: 0
})

export function toCurrency (value: number, formatter?: Intl.NumberFormat): string {
  return isNaN(value) ? '' : (formatter || defaultCurrencyFormatter).format(value)
}
